import { List, Text } from '@mantine/core'
import { FormattedMessage } from 'react-intl'

const MAX_LISTED = 5

type GroupCameraListProps = {
  names: string[]
}

export const GroupCameraList = ({ names }: GroupCameraListProps) => {
  const hidden = names.length - MAX_LISTED

  return (
    <>
      <List size="sm" withPadding>
        {names.slice(0, MAX_LISTED).map((name, index) => (
          <List.Item key={`${name}-${index}`}>
            <span>{name}</span>
          </List.Item>
        ))}
      </List>

      {hidden > 0 && (
        <Text size="sm" c="dimmed" mt={4}>
          <FormattedMessage
            id="deployments.groups.cameras.more"
            values={{ count: hidden }}
          />
        </Text>
      )}
    </>
  )
}
